import { useEffect } from "react";
import { useRouteError } from "react-router-dom";
import { styled } from "styled-components";
import { Trans } from "@lingui/react/macro";
import { Button, Stack, Text } from "@fidelix/fx-miranda";

function isChunkLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  return error.message.includes("Failed to fetch dynamically imported module");
}

// See: https://reactrouter.com/en/main/route/error-element
export function RootRouteError() {
  const error = useRouteError();

  useEffect(() => {
    if (error) {
      if (isChunkLoadError(error)) {
        (async () => {
          try {
            const res = await fetch(`/version.json?t=${Date.now()}`); // t param prevents returing cache
            const { version } = await res.json();

            const lastReloadedVersion = sessionStorage.getItem(
              "last-reloaded-version",
            );

            if (lastReloadedVersion !== String(version)) {
              sessionStorage.setItem("last-reloaded-version", String(version));
              window.location.reload();
            }
          } catch {
            // eslint-disable-next-line no-console
            console.error(error);
          }
        })();
      }
      // TODO: Send the error to an error reporting service
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }, [error]);

  return (
    <Wrapper>
      <Stack axis="y" spacing="medium" align="center">
        <Text variant="title1">
          <Trans>Something went wrong</Trans>
        </Text>
        <Text variant="body">
          <Trans>
            An unexpected error occured. Please try to reload the page or
            contact support.
          </Trans>
        </Text>
        <Button onPress={() => window.location.reload()}>Reload page</Button>
      </Stack>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;
